import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getPatternDefForPage } from './router-config/routerConfig'
import type { RouterConfig } from './router-config/routerConfigTypes'

export async function getCollectionIdAndPatternOfCurrentDynamicPage({
  editorSdkProxy,
}: {
  editorSdkProxy: EditorSDK
}): Promise<{ collectionId: string; pattern: string } | null> {
  const pageRef = await editorSdkProxy.document.pages.getCurrent()
  const routerRef = await editorSdkProxy.document.routers.getByPage({ pageRef })
  if (routerRef) {
    const routerInfo = await editorSdkProxy.document.routers.get<RouterConfig>({
      routerRef,
    })
    const { pattern, def: patternDef } = getPatternDefForPage(
      routerInfo.config,
      routerInfo.pages,
      pageRef,
    )
    if (typeof pattern !== 'undefined') {
      return {
        collectionId: patternDef.config.collection,
        pattern,
      }
    }
  }
  return null
}
